<template>
	<div>
        <div v-show="parent2Show">
            <Form :model="formItem" :label-width="100" inline>
                <Form-item label="任务名称">
                    <Input type="text" v-model="formItem.wname"></Input>
                </Form-item>
                <Form-item label="模板名称">
                    <Input type="text" v-model="formItem.name"></Input>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="init">查询</Button>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="pushFn" v-show="type != 1 && type != 2">发布任务</Button>
                </Form-item>
            </Form>
            <Table border :columns="columns" :data="data"></Table>
            <div class="clearfix page">
                <Page :total="pageTotal" class="fr" @on-change="pageChange" @on-page-size-change="pageSize" :current="formItem.start+1" placement="top" show-elevator show-sizer></Page>
            </div>
            <el-dialog title="修改截止时间" :visible.sync="edateShow">
                <div>
                    <Date-picker
                        type="datetime"
                        style="width:100%"
                        format="yyyy-MM-dd HH:mm:ss"
                        :options="dataOption"
                        placeholder="选择日期和时间"
                        :value="edate"
                        @on-change="edate=$event">
                    </Date-picker>
                </div>
                <div slot="footer" class="dialog-footer">
                    <Button @click="edateShow=false">取 消</Button>
                    <Button type="primary" @click="edateFn">确 定</Button>
                </div>
            </el-dialog>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data(){
        	return{
        		formItem: {
                    bigid:this.$route.query.bigid,
                    wname:'',
                    name:'',
                    start:0,
                    length:10,
                },
                edate:'',
                temid:'',
                woid:'',
                type:localStorage.type,
                columns:[
                    {
                        title: '任务名称',
                        key: 'wname'
                    },{
                        title: '模板名称',
                        key: 'name'
                    },{
                        title: '总量',
                        key: 'quantitynum'
                    },{
                        title: '完成量',
                        key: 'completenum'
                    },{
                        title: '创建人',
                        key: 'username'
                    },{
                        title: '开始时间',
                        key: 'sdate'
                    },{
                        title: '结束时间',
                        key: 'edate'
                    },{
                        title: '创建时间',
                        key: 'cdate'
                    },{
                        title: '操作',
                        width: 290,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({path:'/projectList/taskList/taskChildList',query:{woid:params.row.woid}});
                                        }
                                    }
                                }, '查看'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({path:'/projectList/taskList/tabelList',query:{woid:params.row.woid}});
                                        }
                                    }
                                }, '报表'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{
                                        display:this.type != 1 && this.type != 2? 'inline-blick' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({path:'/projectList/taskList/addToTask',query:{woid:params.row.woid,bigid:this.$route.query.bigid}});
                                        }
                                    }
                                }, '添加任务'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{
                                        display:this.type != 1 && this.type != 2? 'inline-blick' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.edateShow=true;
                                            this.edate=params.row.edate;
                                            this.woid=params.row.woid;
                                        }
                                    }
                                }, '修改时间'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{
                                        display:this.type != 1 && this.type != 2? 'inline-blick' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                title: '删除大任务',
                                                content:'确认要删除大任务吗？',
                                                onOk:() => {
                                                    this.delete(params.row.woid);
                                                }
                                            });
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    }
                ],
                data:[],
                pageTotal:0,
                edateShow:false,
                dataOption:{
                    disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                    }
                }
        	}
        },
        watch:{
            $route(to,from){
                if(to.path == '/projectList/taskList'){
                    this.$store.dispatch('parent2ShowFn');
                    this.getData();
                }
            }
        },
        computed: {
            parent2Show () {
                return this.$store.state.parent2Show;
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
            this.getData();
        },
        methods:{
            edateFn(){
                let _this=this;
                this.$http.post('/web/workorder/updatWorkOrder',{woid:_this.woid,endtime:_this.edate}).then(function(res){
                    _this.edateShow=false;
                    if(res){
                        _this.$Notice.success({
                            title:'修改截止时间',
                            desc:res.message
                        })
                        _this.getData();
                    }else{
                        _this.$Notice.error({
                            title:'修改截止时间',
                            desc:res.message
                        })
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title:'修改截止时间',
                        desc:'数据传输失败'
                    })
                });
            },
            delete(woid){
                let _this=this;
                this.$http.post('/web/workorder/deleteWorkOrder',{woid:woid}).then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title:'删除大任务',
                            desc:res.message
                        })
                        _this.getData();
                    }else{
                        _this.$Notice.error({
                            title:'删除大任务',
                            desc:res.message
                        })
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title:'删除大任务',
                        desc:'数据传输失败'
                    })
                });
            },
            pushFn(){
                this.$router.push({path:'/projectList/taskList/addTask',query:{bigid:this.$route.query.bigid}});
            },
            getData(){
                var _this=this;
                this.$http.get('/web/workorder/getWorkOrderList',{
                    params:_this.formItem
                }).then(function(res){
                    _this.data=res.data;
                    _this.pageTotal=res.recordsTotal;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
            pageChange(res){
                this.formItem.start=res-1;
                this.getData();
            },
            pageSize(res){
                this.formItem.length=res;
                this.getData();
            },
            init(){
                this.formItem.start=0;
                this.getData();
            },
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/task/taskList.vue